import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';

import { fetchUserAccount } from 'actions/user';
import FlightsSearchEdit from 'components/FlightsSearchEdit';
import useUserAccount from 'hooks/useUserAccount';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { getAllBillingCompanies } from 'services/billingCompanyService';
import { getAllowedTravelers, TravelArrangerUsersAllowed } from 'services/userService';

type Props = {
  show: boolean;
  onClose: () => void;
};

const FlightsSearchEditContainer = (props: Props) => {
  const dispatch = useDispatch();
  const user = useUserAccount();
  const [allowedTravelers, setAllowedTravelers] = useState<TravelArrangerUsersAllowed[]>([]);
  const [isLoadingAllowedTravelers, setLoadingAllowedTravelers] = useState(true);
  const [isLoadedAllowedTravelers, setLoadedAllowedTravelers] = useState(false);
  const [userLoaded, setUserLoaded] = useState(false);
  const [branchCompanies, setBranchCompanies] = useState<GetAllBillingCompanyResponse[]>([]);
  const [isLoadingBranchCompanies, setIsLoadingBranchCompanies] = useState(false);
  const companyId = useSelector((state: RootState) => state.user.accountResult?.companyId);

  useEffect(() => {
    const fetch = async () => {
      if (!userLoaded) return;
      setLoadedAllowedTravelers(true);

      if (!user?.isTravelArranger) {
        setLoadingAllowedTravelers(false);
        return;
      }

      const { data } = await getAllowedTravelers();

      setAllowedTravelers(data);
      setLoadingAllowedTravelers(false);
    };

    if (!isLoadedAllowedTravelers) fetch();
  }, [isLoadedAllowedTravelers, user, userLoaded]);

  useEffect(() => {
    if (user) {
      setUserLoaded(true);
    } else {
      const fetch = async () => {
        await dispatch(fetchUserAccount());
        setUserLoaded(true);
      };
      fetch();
    }
  }, [dispatch, user]);

  useEffect(() => {
    setIsLoadingBranchCompanies(true);
    getAllBillingCompanies(companyId ?? '').then((res) => {
      if (res.length > 1) {
        setBranchCompanies(res.slice(1));
      } else {
        setBranchCompanies(res);
      }
      setIsLoadingBranchCompanies(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FlightsSearchEdit
      {...props}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      branchCompanies={branchCompanies}
    />
  );
};
export default FlightsSearchEditContainer;
